import React from 'react';
import { TablePaginationConfig } from 'antd/lib/table';
import Skeleton from 'react-loading-skeleton';

import './index.less';

import { ToolsetModel, ToolsetState } from '../../../../../../gamma-api';
import IbPagination from '../../../../../components/common/IbPagination';
import { TOOLSETS_PAGE_SIZE } from '../const';
import ToolsetListItem from '../ToolsetListItem';

import {
  MAIN_CLASS_NAME,
  LIST_CLASS_NAME,
  PAGINATION_ROW_CLASS_NAME,
  SKELETON_ROW_COUNT,
  SKELETON_HEIGHT,
  SKELETON_BORDER_RADIUS,
} from './const';

export interface IToolsetListProps {
  dataLoading: boolean;
  pageLoading: boolean;
  toolsets: ToolsetModel[];
  pagination: TablePaginationConfig;
  onSetup?: (toolset: ToolsetModel) => void;
  onDelete?: (toolset: ToolsetModel) => void;
  onPaginationChange?: (page: number) => void;
  onToolsetStateChange?: (toolset: ToolsetModel, state: ToolsetState) => void;
}

const ToolsetList: React.FC<IToolsetListProps> = ({
  dataLoading,
  pageLoading,
  toolsets,
  pagination,
  onSetup,
  onDelete,
  onPaginationChange,
  onToolsetStateChange,
}) => {
  return (
    <div className={MAIN_CLASS_NAME}>
      <div className={LIST_CLASS_NAME}>
        {dataLoading || pageLoading
          ? Array.from(Array(SKELETON_ROW_COUNT).keys()).map((_, row) => (
              <Skeleton key={row} borderRadius={SKELETON_BORDER_RADIUS} height={SKELETON_HEIGHT} />
            ))
          : toolsets.map((toolset) => (
              <ToolsetListItem
                key={toolset.toolset_id}
                toolset={toolset}
                onDelete={onDelete}
                onSetup={onSetup}
                onToolsetStateChange={onToolsetStateChange}
              />
            ))}
      </div>
      {!dataLoading && (pagination.total ?? 0) > TOOLSETS_PAGE_SIZE && (
        <div className={PAGINATION_ROW_CLASS_NAME}>
          <IbPagination
            current={pagination.current}
            defaultCurrent={1}
            defaultPageSize={TOOLSETS_PAGE_SIZE}
            pageSize={TOOLSETS_PAGE_SIZE}
            showSizeChanger={false}
            total={pagination.total}
            onChange={onPaginationChange}
          />
        </div>
      )}
    </div>
  );
};

export default ToolsetList;
